import { z } from "zod";

/** Email-only create (e.g. legacy / Identities modals) — same route may accept full body in other flows. */
export const createUserRequestSchema = z.object({
  firstName: z.string().min(1, "FirstName is required"),
  lastName: z.string().min(1, "LastName is required"),
  email: z.string().email("Invalid email address"),
  roleKey: z.string(),
});

export type CreateUserRequest = z.infer<typeof createUserRequestSchema>;

/** ISPM "Add user" with role assignment. */
export const addUserRequestSchema = z.object({
  email: z.string().email("Invalid email address"),
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  roleKey: z.string().min(1),
});

export type AddUserRequest = z.infer<typeof addUserRequestSchema>;

export const selectedFilterSchema = z.object({
  field: z.string(),
  operator: z.string(),
  values: z.array(z.string()),
});

export type SelectedFilter = z.infer<typeof selectedFilterSchema>;

export const userTableRequestPayloadSchema = z.object({
  pageSize: z.number(),
  search: z.string().optional(),
  filters: z.array(selectedFilterSchema).optional(),
  sortBy: z.string().optional(),
  sortOrder: z.string().optional(),
  status: z.string().optional(),
  role: z.string().optional(),
  nextPageToken: z.string().optional(),
});

export type UserTableRequestPayload = z.infer<
  typeof userTableRequestPayloadSchema
>;

export const usersTableDataSchema = z
  .object({
    email: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    userId: z.string(),
    status: z.string(),
    createdBy: z.string().nullable(),
    createdByName: z.string().nullable(),
    createdAt: z.number().nullable(),
    statusChangedBy: z.string().nullable(),
    statusChangedByName: z.string().nullable(),
    statusChangedAt: z.number().nullable(),
    lastAccessedAt: z.number().nullable(),
    roles: z.array(z.string()).nullable(),
  })
  .passthrough();

export type UsersTableData = z.infer<typeof usersTableDataSchema>;

export const usersTableSuccessResponseSchema = z.object({
  content: z.array(usersTableDataSchema),
  nextPageToken: z.string().nullish().optional(),
  totalElements: z.number().optional(),
});

export type UsersTableSuccessResponse = z.infer<
  typeof usersTableSuccessResponseSchema
>;

export const userEmailActionSchema = z.object({
  email: z.string().email(),
});

export type UserEmailActionPayload = z.infer<typeof userEmailActionSchema>;

export const userFilterOptionSchema = z.object({
  value: z.string(),
  label: z.string(),
});

export const userFilterDefinitionSchema = z
  .object({
    field: z.string(),
    label: z.string(),
    type: z.string(),
    options: z.array(userFilterOptionSchema),
  })
  .passthrough();

export const userFiltersResponseSchema = z.array(userFilterDefinitionSchema);

export type UserFilterOption = z.infer<typeof userFilterOptionSchema>;
export type UserFilterDefinition = z.infer<typeof userFilterDefinitionSchema>;
